import { Component, HostListener, OnInit } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { AuthService } from './auth/services/auth.service';
import { MenuStorageService } from './menu/services/menu-storage.service';
import { MenuService } from './menu/services/menu.service';

/**
 * Componente principal de la aplicacion
 */
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
  /**
   * Indica si se esta en pantalla mobile o no
   */
  isMobile = true;
  /**
   * Constructor
   *
   * @param auth servicio de autenticacion
   * @param menuService servicio de menu
   * @param meta servicio de meta tags
   */
  constructor(
    private auth: AuthService,
    private menuService: MenuStorageService,
    private responsiveService: MenuService,
    private meta: Meta,
    private router: Router
  ) {
    this.auth.signInWithEmail();
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.checkScreenSize();
  }




  /**
   * Obtiene la info del restaurante actual
   */
  ngOnInit(): void {
    this.getInfoRestaurant();
    this.checkScreenSize();
    const browserLang = navigator.languages?.[0] || navigator.language || (navigator as any).userLanguage;
    const code = browserLang.split('-')[0].toUpperCase();
    this.responsiveService.setLang(code === 'ES' ? 'ES' : 'EN');
  }


  /**
   * Valida el ancho de la pantalla
   * para saber si es mobile o no
   */
  checkScreenSize() {
    const screenWidth = window.innerWidth;
    setTimeout(() => {
      if (screenWidth < 768 || this.router.routerState.snapshot.url.length === 1) {
        this.responsiveService.setIsMobile(true);
        this.isMobile = true;
      } else {
        this.responsiveService.setIsMobile(false);
        this.isMobile = false;
      }
    }, 1000);

  }

  /**
   * Establece el meta tag de descripcion segun el restaurante actual
   */
  private getInfoRestaurant(): void {
    this.menuService.getRestaurant().subscribe((r) => {
      if (r) {
        this.meta.updateTag({ name: 'description', content: `Menú ${r.name}. By Eazzy` });
      }
    });
  }

}
